import { ReactNode } from 'react';
import cx from 'classnames';
import { Heading } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './TopBar.module.scss';
import EntitySelection from 'Components/TopBar/EntitySelection/EntitySelection';
import useGetUser from 'hooks/useGetUser';
import useGetCurrentEntityId from 'hooks/useGetCurrentEntityId';
import { UserRole } from 'api/dtos/user';

type Props = {
    title: string;
    description: string;
    icon?: ReactNode;
}

const TopBar = ({ title, description, icon }: Props) => {
    const intl = useIntl();
    const user = useGetUser();
    const currentEntityId = useGetCurrentEntityId();
    const currentEntity = (user?.entities ?? []).find((e) => e.id === currentEntityId);
    const isGuestInCurrentEntity = currentEntity?.role === UserRole.Guest;

    return (
        <div className={styles.container}>
            <div className={cx(styles.titleContainer)}>
                <div className={styles.headingContainer}>
                    {icon && <div className={styles.iconContainer}>{icon}</div>}
                    <Heading className={cx(styles.title)}>{title}</Heading>
                </div>
                <p className={styles.description}>{description}</p>
            </div>
            <div />
            <div className={styles.commonContainer}>
                {isGuestInCurrentEntity && (
                    <div className={styles.guestInfo}>
                        {intl.formatMessage(messages.guestInfo)}
                    </div>
                )}
                <EntitySelection />
            </div>
        </div>
    );
};

const messages = defineMessages({
    guestInfo: {
        id: 'src.components.TopBar.TopBar.guestInfo',
        defaultMessage: 'Masz najniższe uprawnienia w tej grupie (Gość). Część funkcji i danych jest ukryta.',
    },
});

export default TopBar;
